import { SearchInput } from "@flexfreight/ui";
import { useState } from "react";
import { Link } from "react-router";
import { useConsoleMe } from "../../auth/context";
import { settingGroupsFor } from "./settingsCatalog";

/** Admin Center hub (/admin): every setting this staff member may open, grouped into cards, with one search. */
export function AdminHomePage() {
  const me = useConsoleMe();
  const [term, setTerm] = useState("");
  const groups = settingGroupsFor(me.capabilities, term);
  return (
    <section className="ffa-page ffa-settings">
      <header className="ffa-head">
        <div>
          <h1 className="ffa-page__title">Admin Center</h1>
          <p className="ffa-head__sub">Every setting in one place. Pick a card or search.</p>
        </div>
      </header>
      <SearchInput className="ffa-settings__search" label="Search settings" placeholder="Search settings: carriers, Zoho, two-step, team..." value={term} onChange={setTerm} />
      {groups.length ? (
        <div className="ffa-settings__grid">
          {groups.map((g) => (
            <section key={g.id} className="ffa-settings__card" aria-labelledby={`set-${g.id}`}>
              <h2 id={`set-${g.id}`} className="ffa-settings__label">{g.label}</h2>
              <ul className="ffa-settings__links">
                {g.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="ffa-settings__link">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      ) : (
        <p className="ffa-muted">No setting matches &ldquo;{term}&rdquo;.</p>
      )}
    </section>
  );
}
